import { Bound, deserializeXYWH } from '@blocksuite/global/gfx';

import type { CanvasSelectionBounds } from '../components/ai-chat-content/type';

export function finiteBoundsFromXYWH(
  xywh: unknown
): CanvasSelectionBounds | undefined {
  if (typeof xywh !== 'string') return undefined;

  try {
    const bound = Bound.fromXYWH(deserializeXYWH(xywh));
    const values = [bound.x, bound.y, bound.w, bound.h];
    if (!values.every(Number.isFinite)) return undefined;

    return {
      x: Math.round(bound.x),
      y: Math.round(bound.y),
      w: Math.round(bound.w),
      h: Math.round(bound.h),
    };
  } catch {
    return undefined;
  }
}

export function finiteBoundsFromCanvasModel(model: {
  xywh?: unknown;
  props?: Record<string, unknown>;
}): CanvasSelectionBounds | undefined {
  return finiteBoundsFromXYWH(model.xywh ?? model.props?.xywh);
}
